<template>
  <div class="FurtherActions">
    <div class="further-actions">
      <!-- <div class="further-action" @click="togglePrizeModal()">
        <div class="further-action-icon">
          <i
            v-if="assignment.is_pubby_prize"
            class="material-icons further-icon-done-empty"
            >check_circle</i
          >
          <img
            src="/images/icons/further-prize.svg"
            class="further-action-icon-img"
          />
          <i
            v-if="assignment.is_pubby_prize"
            class="material-icons further-icon-done"
            >check_circle</i
          >
        </div>
        <div class="further-action-label">Give Prize</div>
        <div class="further-action-line" v-if="showPrizeModal"></div>
      </div> -->

      <div class="further-action" @click="toggleReportModal()">
        <div class="further-action-icon">
          <img
            src="/images/icons/further-report.png"
            class="further-action-icon-img"
          />
        </div>
        <div class="further-action-label">Report<span v-if="isReportIssueLoaded">ed</span> Issue</div>
        <div class="further-action-line" v-if="showReportModal"></div>
      </div>
    </div>

    <div class="further-modal" v-if="showPrizeModal">
      <template v-if="!assignment.is_pubby_prize">
        <div class="further-modal-p">
          We're working on improvements to the Pubby Prize at the moment. Please
          come back to reward this review at a later date. Thank you!
        </div>
        <!-- <div class="further-modal-p">
          We encourage authors to reward reviews that are especially
          constructive or well-written. The reviewer will receive a bonus of 300
          snaps as a prize. The snaps will be given by us and will
          <i>not</i> be taken from your account.
        </div>
        <div class="further-modal-heading">
          What was great about this review?
        </div>
        <div class="further-compliments">
          <div
            class="further-compliment"
            :class="{ 'further-compliment-enabled': compliments['1'] }"
            @click="toggleCompliment('1')"
          >
            <div class="further-compliment-icon">&#128064;</div>
            <div class="further-compliment-label">Great length</div>
          </div>

          <div
            class="further-compliment"
            :class="{
              'further-compliment-enabled': compliments['2'],
            }"
            @click="toggleCompliment('2')"
          >
            <div class="further-compliment-icon">👏</div>
            <div class="further-compliment-label">Very Persuasive</div>
          </div>

          <div
            class="further-compliment"
            :class="{
              'further-compliment-enabled': compliments['3'],
            }"
            @click="toggleCompliment('3')"
          >
            <div class="further-compliment-icon">✍️</div>
            <div class="further-compliment-label">Detailed & Specific</div>
          </div>

          <div
            class="further-compliment"
            :class="{
              'further-compliment-enabled': compliments['4'],
            }"
            @click="toggleCompliment('4')"
          >
            <div class="further-compliment-icon">😂</div>
            <div class="further-compliment-label">Funny & Charming</div>
          </div>
        </div>
        <div class="further-confirm" @click="clickGivePrize()">Give Prize</div> -->
      </template>
      <template v-else>
        <div class="further-modal-p">
          You gave this review a Pubby Prize and the reviewer was rewarded.<br />
          Thank you for your selection!
        </div>
      </template>
    </div>

    <div class="further-modal" v-if="showReportModal">
      <template v-if="!isReportIssueLoaded">&nbsp;</template>
      <template v-else-if="user.refunds_available === 0">
        <div class="further-modal-p">
          Unfortunately, you've used all of your Review Refunds so we will not be able to refund this review.
          You will get 10 more review refunds on your next yearly anniversary on {{ user.refund_anniversary }}
        </div>
      </template>
      <template v-else-if="!hasReportIssue">
        <div class="further-modal-p">
          If you've found an issue with the content of this review, you can
          report it to our staff here. You will receive a full refund of your snaps.
        </div>
        <div class="further-modal-heading">
          What is the issue with this review?
        </div>
        <div class="further-issues">
          <div v-for="i in reviewIssues" :key="i.id">
            <div
              class="further-issue"
              :class="{ 'further-issue-enabled': issue == i.id }"
              @click="toggleIssue(i.id)"
            >
              <div class="further-issue-icon">
                <i class="material-icons further-issue-warning-icon">error</i>
              </div>
              <div class="further-issue-label">{{ i.label }}</div>
            </div>
          </div>
        </div>

        <div class="further-issue-more" v-if="issue > 0">
          <div v-if="issueDescriptionText" class="further-modal-subheading">
            {{ issueDescriptionText }}
          </div>
          <div class="further-modal-subheading">
            Please write any additional information that may help our staff
            understand and corroborate the issue. (Optional)
          </div>
          <textarea v-model="issueContent" class="message-text"></textarea>
          <div class="further-modal-subheading">
            <span v-if="user.refunds_available === 1">This will be your last review refund allowed until you earn 10 more at your next anniversary on {{ user.refund_anniversary }}</span>
            <span v-else>By reporting this issue, you will use one of your {{ user.refunds_available }} available review refunds.</span>
          </div>
        </div>

        <div class="further-confirm" @click="clickReportIssue()">
          Refund Review <span v-if="isReportableIssue"> and Report Issue</span>
        </div>
      </template>
      <template
        v-else-if="
          hasReportIssue && reportIssue && reportIssue.status === 'Approved'
        "
      >
        <div v-if="reportIssue.author_message" class="further-modal-p" v-html="reportIssue.author_message"></div>
        <div v-else class="further-modal-p">
          Our staff was able to corroborate your issue and a full refund of
          <b>{{ reportIssue.snaps }} snaps</b> was added to your account by our
          staff. Thank you for reporting this issue!
        </div>
      </template>
      <template
        v-else-if="
          hasReportIssue && reportIssue && reportIssue.status === 'Rejected'
        "
      >
        <div class="further-modal-p">
          Our team could not corroborate your reported issue with the review. However, you received a snap refund upon your initial reporting of the review. 
          We will not be taking further action with the reviewer regarding this matter. Thank you for your understanding.
        </div>
      </template>
      <template
        v-else-if="
          hasReportIssue && reportIssue && reportIssue.status === 'Pending'
        "
      >
        <div class="further-modal-p" v-html="reportIssue.author_message"></div>
      </template>
      <template v-else>
        <div class="further-modal-p">
          Thank you for reporting your issue. You have immediately received a snap refund for this review. 
          Please refresh the page if necessary to see this update reflected. 
          This message will change as this report is processed by our team. Thank you for your patience.
        </div>
      </template>
    </div>
  </div>
</template>


<script>
import StatusMessages from "./StatusMessages";
import AssignmentFooter from "./AssignmentFooter";
import Back from "../../modules/Back";
import Bus from "../../modules/Bus";
import { mapState } from "vuex";

export default {
  name: "Review",
  components: { "status-messages": StatusMessages, AssignmentFooter },
  props: ["review", "assignment"],
  data: function () {
    return {
      showPrizeModal: false,
      showReportModal: false,
      hasReportIssue: false,
      reportIssue: null,
      isReportIssueLoaded: false,
      compliments: {
        1: false,
        2: false,
        3: false,
        4: false,
      },
      selectedIssue: 0,
      issue: 0,
      issueContent: null,
    };
  },
  mounted() {
    if (this.assignment.review_issue) {
      this.hasReportIssue = true;
      this.isReportIssueLoaded = true;
      this.reportIssue = this.assignment.review_issue;
      this.showReportModal = true;
    }
  },
  computed: {
    ...mapState({
      user: "user",
      reviewIssues: "reviewIssues"
    }),
    isReportableIssue() {
      if (!this.issue) {
        return false
      }

      var issue = findIssueById(this.reviewIssues, this.issue)
      if (!issue) {
        return false
      }
      return (this.issue === 1 && this.issueContent) || issue.strike_reader

    },
    issueDescriptionText() {
      if (!this.issue) {
        return ''
      }

      var issue = findIssueById(this.reviewIssues, this.issue)
      if (!issue) {
        return ''
      }
      if ((this.issue === 1 && this.issueContent) || issue.requires_approval) {
          if (issue.request_edit) {
            return "If our staff can corroborate the innacuracies, we'll also request that the reviewer correct or delete their review on Amazon."
          } else if (issue.request_delete) {
            return "If our staff can corroborate your identified issue, we'll also request that the review be deleted from Amazon."
          } else {
            return ''
          }
      }
    },
  },
  methods: {
    copyLink() {
      this.$toasted.show(
        "The link has been copied! Paste it into your browser to visit the Amazon page, or share it with others!",
        {
          icon: "link",
          position: "bottom-center",
          duration: 4000,
        }
      );
      copyToClipboard(this.review.url);
    },
    togglePrizeModal() {
      this.showPrizeModal = !this.showPrizeModal;
      this.showReportModal = false;
    },
    toggleReportModal() {
      if (!this.isReportIssueLoaded) {
        this.loadReportIssue();
      }

      this.showReportModal = !this.showReportModal;
      this.showPrizeModal = false;
    },
    toggleCompliment(name) {
      if (!this.compliments[name]) {
        this.compliments[name] = true;
      } else {
        this.compliments[name] = false;
      }
    },
    toggleIssue(issue) {
      if (this.issue === issue) {
        this.issue = 0
      } else {
        this.issue = issue;
      }
    },
    async clickGivePrize() {
      // console.log("clickGivePrize", this.review, this.compliments);

      const response = await Back.givePrize(
        this.review.assignment_id,
        this.compliments
      );

      this.assignment.is_pubby_prize = true;
      this.showPrizeModal = false;

      this.$toasted.show(
        "Great, we'll let the reviewer know! Thank you for your selection!",
        {
          icon: "check_circle",
          position: "bottom-center",
          duration: 4000,
          fullWidth: false,
        }
      );

      // console.log("response", response);
    },
    async clickReportIssue() {
      // console.log(
      //   "clickReportIssue",
      //   this.review,
      //   this.issue,
      //   this.issueContent
      // );

      var issueId = this.issue
      var message = "Your review has been refunded!"
      
      if (this.issue < 1) {
        issueId = 1
      }

      const issue = findIssueById(this.reviewIssues, issueId)
      if ((issueId === 1 && this.issueContent) || issue.requires_approval) {
        message = "Your review has been refunded and the issue has been reported! Check back here for an update within 48 hours."
      }

      await Back.reportReviewIssue(
        {
          'assignment_id': this.review.assignment_id,
          'issue': issueId,
          'user_content': this.issueContent
        }
      )
      .then((response) => {
        if (!response) {
          return this.$toasted.show(
            "Oops! Something went wrong. Please try again later or contact our support team.",
              {
                icon: "error",
                position: "bottom-center",
                duration: 4000,
              }
            );
        }
        this.$toasted.show(
          message,
          {
            icon: "check_circle",
            position: "bottom-center",
            duration: 4000,
            fullWidth: false,
          }
        );
        this.hasReportIssue = true;
        // console.log(response)
        Bus.$emit("UserChanged",null)
      })

      
      

      // console.log("response", response);
    },
    async loadReportIssue() {
      const response = await Back.getReviewIssue(this.assignment.id);

      if (response && response["no_issue"]) {
        this.hasReportIssue = false;
        this.isReportIssueLoaded = true;
        // console.log(
        //   "loadReportIssue",
        //   this.hasReportIssue,
        //   this.isReportIssueLoaded
        // );
        // console.log("has no issue");
        return;
      }

      this.hasReportIssue = true;
      this.isReportIssueLoaded = true;
      this.reportIssue = response;

      // console.log(
      //   "loadReportIssue",
      //   this.hasReportIssue,
      //   this.isReportIssueLoaded,
      //   this.reportIssue
      // );
      // console.log("has issue");
    },
  },
};

function findIssueById(issues, id) {
  if (!issues || !id) {
    return null;
  }

  for (const i in issues) {
    if (issues[i].id == id) {
      return issues[i];
    }
  }

  return null;
}

function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    return clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
</script>

<style lang="scss" scoped>
.further-actions {
  display: flex;
  padding: 8px 0 0 0;
}

.further-action {
  max-width: 132px;
  min-width: 122px;
  margin-right: 16px;
  border: 0px solid #e3e3e3;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.04);
  }
}
.further-action-icon {
  text-align: center;
}
.further-action-icon-img {
  height: 36px;
}
.further-action-label {
  font-size: 11.5pt;
  font-weight: 700;
  color: $color-blue;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-align: center;
}
.further-icon-done {
  margin-top: 4px;
  margin-right: 2px;
  font-size: 13pt;
  color: $color-blue;
}
.further-icon-done-empty {
  color: #fff;
}
.further-action-text {
}

.further-action-line {
  width: 32px;
  height: 10px;
  background: #fff;
  margin: 0 auto;
  margin-bottom: -1px;
  margin-top: 10px;
  border-left: 1px solid #e3e3e3;
  border-right: 1px solid #e3e3e3;
}

.further-modal {
  border: 1px solid #e3e3e3;
  background: #fff;
  border-radius: 8px;
  padding: 0px 0px;
}

.further-modal-p {
  padding: 20px 26px;
}
.further-modal-heading {
  padding: 10px 26px;
  font-size: 13.5pt;
  font-weight: 600;
}
.further-modal-subheading {
  padding: 10px 26px;
  font-size: 13.5pt;
  font-weight: 500;
}

.further-compliments {
  padding: 0px 12px 20px 26px;
  display: flex;
  flex-flow: row wrap;
}
.further-compliment {
  display: flex;
  width: 216px;
  min-width: 216px;
  margin-right: 16px;
  margin-bottom: 3px;
  border: 0px solid #e3e3e3;
  border-radius: 8px;
  padding: 4px 0 4px 8px;
  border: 1px solid #fff;

  &:hover {
    background: lighten(#daedff, 3%);
    cursor: pointer;
  }
}
.further-compliment-enabled {
  background: lighten(#daedff, 3%);
  border: 1px solid darken(#daedff, 8%);
}
.further-compliment-icon {
  text-align: center;
  font-size: 18pt !important;
}
.further-compliment-icon-img {
  height: 28px;
}
.further-compliment-label {
  padding-left: 12px;
  padding-top: 3px;
  font-size: 11.5pt;
  font-weight: 600;
  color: #111;
  color: $color-blue;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-align: center;
}

.further-confirm {
  border-top: 1px solid #e3e3e3;
  padding: 15px 0;
  color: $color-blue;
  letter-spacing: 1px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  font-size: 12.5pt;
  border-radius: 0 0 8px 8px;
  background: lighten(#daedff, 4%);

  &:hover {
    background: lighten(#daedff, 2%);
    cursor: pointer;
  }
}

.further-issues {
  padding: 0px 12px 20px 26px;
  display: flex;
  flex-flow: row wrap;
}
.further-issue {
  display: flex;
  width: 276px;
  min-width: 276px;
  margin-right: 16px;
  margin-bottom: 3px;
  border: 0px solid #e3e3e3;
  border-radius: 8px;
  padding: 4px 0 4px 8px;
  border: 1px solid #fff;

  &:hover {
    background: lighten(#daedff, 3%);
    cursor: pointer;
  }
}
.further-issue-enabled {
  background: lighten(#daedff, 3%);
  border: 1px solid darken(#daedff, 8%);
}
.further-issue-icon {
  text-align: center;
  font-size: 18pt !important;
  padding-top: 4px;
}
.further-issue-warning-icon {
  font-size: 15pt;
  color: #fbc02d;
}
.further-issue-label {
  padding-left: 12px;
  padding-top: 3px;
  font-size: 12.5pt;
  font-weight: 600;
  color: $color-blue;
}

.message-text {
  width: 88%;
  height: 128px;
  margin: 26px 26px;
  margin-top: 4px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 6px 12px;
  font-family: $font-family;
  font-size: 13pt;
  outline: none;
}
</style>